import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 27 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M25.3333 28.6923C25.3333 29.3043 25.1034 29.8913 24.6942 30.3241C24.285 30.7569 23.7301 31 23.1514 31H3.51507C2.93642 31 2.38146 30.7569 1.97229 30.3241C1.56312 29.8913 1.33325 29.3043 1.33325 28.6923V3.30769C1.33325 2.69565 1.56312 2.10868 1.97229 1.67591C2.38146 1.24313 2.93642 1 3.51507 1H14.4242L25.3333 12.5385V28.6923Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.87866 19.2886L11.2537 21.5386L16.8787 12.5386",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgFileCheck);
export default ForwardRef;
